<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<h2>Import Resource</h2>

<form [formGroup]="form" (ngSubmit)="import()">
  <div class="d-flex flex-column">
    <mat-form-field floatLabel="always">
      <mat-label>Address</mat-label>
      <input
        matInput
        formControlName="address"
        matTooltip="Address of the Resource to import"
        />
    </mat-form-field>

    <mat-form-field floatLabel="always">
      <mat-label>Id</mat-label>
      <input
        matInput
        formControlName="id"
        matTooltip="Id of the Resource to import. The format of this field is Resource specific."
        />
    </mat-form-field>

    <div class="d-flex flex-row justify-content-around align-items-center">
      <button
        type="submit"
        color="primary"
        mat-raised-button
        [disabled]="!form.valid"
        >
        @if (!loading) {
          <div>Import</div>
        } @else {
          <mat-progress-spinner
            color="accent"
            diameter="35"
            mode="indeterminate"
            >
          </mat-progress-spinner>
        }

      </button>

      <button type="reset" color="primary" mat-raised-button (click)="cancel()">
        Cancel
      </button>
    </div>

    <div class="output" matTooltip="Results of the import command">
      <cas-output [loading]="false" [output]="message"></cas-output>
    </div>
  </div>
</form>
